import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
//Plugins
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatDatepickerModule} from '@angular/material/datepicker'
import {MatNativeDateModule, MAT_DATE_LOCALE} from '@angular/material/';
import { IonicStorageModule } from '@ionic/storage';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import { QRCodeModule } from 'angularx-qrcode';

//Modules
import {MatInputModule} from '@angular/material/input';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
// Modals
import { ProductSlidesPageModule } from './modals/product-slides/product-slides.module';
import { ProductSlidesPage } from './modals/product-slides/product-slides.page';
import { ModalAddAddressPageModule } from './modals/modal-add-address/modal-add-address.module';
import { ModalAddAddressPage } from './modals/modal-add-address/modal-add-address.page';
import { ModalPointsInfoPageModule } from './modals/modal-points-info/modal-points-info.module';
import { ModalPointsInfoPage } from './modals/modal-points-info/modal-points-info.page';
import { ModalRedeemCouponPageModule } from './modals/modal-redeem-coupon/modal-redeem-coupon.module';
import { ModalRedeemCouponPage } from './modals/modal-redeem-coupon/modal-redeem-coupon.page';
import { ModalOrderDetailPageModule } from './modals/modal-order-detail/modal-order-detail.module';
import { ModalOrderDetailPage } from './modals/modal-order-detail/modal-order-detail.page';
import { RestorePasswordPageModule } from './modals/restore-password/restore-password.module';
import { RestorePasswordPage } from './modals/restore-password/restore-password.page';
import { ModalCodeQuestionPageModule } from './modals/modal-code-question/modal-code-question.module';
import { ModalCodeQuestionPage } from './modals/modal-code-question/modal-code-question.page';
import { ModalCompleteInformationPageModule } from './modals/modal-complete-information/modal-complete-information.module';
import { ModalCompleteInformationPage } from  './modals/modal-complete-information/modal-complete-information.page';
import { ModalRedeemInsurancePageModule } from './modals/modal-redeem-insurance/modal-redeem-insurance.module';
import { ModalRedeemInsurancePage } from './modals/modal-redeem-insurance/modal-redeem-insurance.page';
import { ModalRequestTigoSaleOrderPageModule } from './modals/tigo/modal-request-tigo-sale-order/modal-request-tigo-sale-order.module';
import { ModalRequestTigoSaleOrderPage } from './modals/tigo/modal-request-tigo-sale-order/modal-request-tigo-sale-order.page';
import { NewsDetailPageModule } from './modals/news-detail/news-detail.module';
import { PostCommentsPageModule } from './modals/post-comments/post-comments.module';
import { ModalUserGoalStatePage } from './modals/modal-user-goal-state/modal-user-goal-state.page';
import { ModalUserGoalStatePageModule } from './modals/modal-user-goal-state/modal-user-goal-state.module';
import { ModalUserAnswersQuestionsPage } from './modals/modal-user-answers-questions/modal-user-answers-questions.page';
import { ModalUserAnswersQuestionsPageModule } from './modals/modal-user-answers-questions/modal-user-answers-questions.module';
import { AcceptTermsAndConditionsPageModule } from './modals/accept-terms-and-conditions/accept-terms-and-conditions.module';
import { AcceptTermsAndConditionsPage } from './modals/accept-terms-and-conditions/accept-terms-and-conditions.page';
import { AutomaticPointsSettingsPage } from './modals/automatic-points-settings/automatic-points-settings.page';
import { AutomaticPointsSettingsPageModule } from './modals/automatic-points-settings/automatic-points-settings.module';
import { ModalIaModulePage } from './modals/modal-ia-module/modal-ia-module.page';
import { ModalIaModulePageModule } from './modals/modal-ia-module/modal-ia-module.module';
import { RankingPage } from './pages/ranking/ranking.page';
import { RankingPageModule } from './pages/ranking/ranking.module';




@NgModule({
  declarations: [AppComponent],
  entryComponents: [
    ProductSlidesPage, 
    ModalAddAddressPage,
    ModalPointsInfoPage,
    ModalRedeemCouponPage,
    ModalRedeemInsurancePage,
    ModalOrderDetailPage,
    RestorePasswordPage,
    ModalCodeQuestionPage,
    ModalCompleteInformationPage,
    ModalRequestTigoSaleOrderPage,
    ModalUserGoalStatePage,
    ModalUserAnswersQuestionsPage,
    AcceptTermsAndConditionsPage,
    AutomaticPointsSettingsPage,
    ModalIaModulePage,
    RankingPage
  ],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    IonicStorageModule.forRoot(),
    InfiniteScrollModule,
    AppRoutingModule,
    MatInputModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    ZXingScannerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ProductSlidesPageModule,
    ModalAddAddressPageModule,
    ModalPointsInfoPageModule,
    ModalRedeemCouponPageModule,
    ModalRedeemInsurancePageModule,
    ModalOrderDetailPageModule,
    RestorePasswordPageModule,
    ModalCodeQuestionPageModule,
    ModalCompleteInformationPageModule,
    ModalRequestTigoSaleOrderPageModule,
    QRCodeModule,
    NewsDetailPageModule,
    PostCommentsPageModule,
    ModalUserGoalStatePageModule,
    ModalUserAnswersQuestionsPageModule,
    AcceptTermsAndConditionsPageModule,
    AutomaticPointsSettingsPageModule,
    ModalIaModulePageModule,
    RankingPageModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: MAT_DATE_LOCALE, useValue: 'es-GB' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
